import { NavItem } from "./nav-item";

export class NavItems {
  public static autoInit() {
    const navItems = new this();
    const elements = navItems.navItemElements;
    navItems.navItems = elements.map((elm) => new NavItem(elm));
  }

  public navItems: NavItem[];

  public get navItemElements(): HTMLAnchorElement[] {
    const $elements = document.querySelectorAll(NavItem.SELECTOR);
    const elements = Array.prototype.slice.call($elements);
    return elements;
  }
}



// WEBPACK FOOTER //
// ./components/nav-items/nav-items.ts